export default {
    authDonor: false,
    csrfToken: '',
    createNewAccountData: {
        email: '',
        password: '',
        passwordConfirm: '',
        firstName: '',
        lastName: '',
        dob: '',
        idDonationOrDonor: '',
        phoneMobile: '',
        idDonor: '',
        smsOptedOut: null,
        activationCode: 'test',
    },
    showPage: {
        triggerRequestActivationCode: false,
        triggerEnterActivationCode: false,
    },
}
